import Request from './request';

const { VITE_API_BASE_URL, VITE_API_PREFIX, VITE_API_VERSION } = import.meta.env;

export default new Request({
    baseURL: `${VITE_API_BASE_URL}`
    // baseURL: `http://172.19.18.10:5002/${VITE_API_PREFIX}/${VITE_API_VERSION}`
});
